import styled from 'styled-components';

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  position: absolute;
  align-items: center;
  background-color: #fff;
  justify-content: center;

  img {
    width: 80px;
    height: 80px;
  }
`;
